exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-components-___DealSummary__container___3iFjF{display:flex}@media (max-width:599px){.web-components-___DealSummary__container___3iFjF{flex-direction:column}}.web-components-___DealSummary__left___3dEKM{flex:1;padding-right:2em}@media (max-width:599px){.web-components-___DealSummary__left___3dEKM{padding-right:0}}.web-components-___DealSummary__picture___1hf3u{width:100%;border-radius:3px}.web-components-___DealSummary__right___29lKy{flex:2}@media (max-width:599px){.web-components-___DealSummary__right___29lKy{padding-top:1em}}.web-components-___DealSummary__left___3dEKM>button{width:100%}", ""]);

// exports
exports.locals = {
	"container": "web-components-___DealSummary__container___3iFjF",
	"left": "web-components-___DealSummary__left___3dEKM",
	"picture": "web-components-___DealSummary__picture___1hf3u",
	"right": "web-components-___DealSummary__right___29lKy"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/components/DealSummary.css
// module id = 1329
// module chunks = 0